<h1 mat-dialog-title>{{ title | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'inbox-dialog-desc' | translate }}</p>
  <div class="example-container">
    <form [formGroup]="ticketDatas">
      <mat-form-field appearance="fill" class="form-email" style="width: 100%" *ngIf="this.data_ActivityCode == 2">
        <mat-label>{{ 'help_category' | translate }}</mat-label>
        <mat-select class="category" placeholder="asd" formControlName="category" [(value)]="selectedCategory" required>
          <mat-option *ngFor="let x of categoryList" [value]="x.id">
            {{ x.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <textarea matInput placeholder="{{ 'Message' | translate }}" formControlName="Message"></textarea>
      </mat-form-field>

      <!--      <input #file type="file" multiple (change)="upload(file.files)" />-->

      <div class="upload-btn-wrapper">
        <button class="inbox_upload_btn">{{ 'Upload_a_file' | translate }}</button>
        <input #file type="file" multiple (change)="upload(file.files)" />
      </div>
      <img src="{{ this.input_filepath }}" style="margin: 0px; display: block" alt="İmage" *ngIf="this.input_filepath !== ''" />
    </form>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%; color: white; font-weight: bold" (click)="createCustomerTicket()">
    {{ 'Send' | translate }}
  </button>

  <button
    mat-stroked-button
    style="width: 100%; margin-top: 8px; margin-left: 0; background: linear-gradient(135deg, #cc0b0b 0%, #ff0202 100%); color: white; font-weight: bold"
    (click)="onNoClick()">
    {{ 'Cancel' | translate }}
  </button>
</div>
